module.exports = __webpack_public_path__ + "media/images/new_landing/people/kristyna-sadilkova-481ce00d80464cfe8914d5eccfba7c94.jpg";